// extracted by mini-css-extract-plugin
export default {"tooltipContent":"PricingDetailsTooltip_tooltipContent__m4y0M","color-text-secondary":"PricingDetailsTooltip_color-text-secondary__3Q5++"};